import script from "./References.vue?vue&type=script&setup=true&lang=js"
export * from "./References.vue?vue&type=script&setup=true&lang=js"

import "./References.vue?vue&type=style&index=0&id=1f4cce72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4cce72"]])

export default __exports__